module.exports = __webpack_public_path__ + "img/7_59.2f1207bf.png";